/* Sparq dropdown: "SUBMIT THE SEARCH" button goes to /search?q=<typed text> */
(function () {
  var BUTTON = '.--view-all-btn a, .sq-submit-search';
  var INPUT = "input[name='q'], input[type='search']";
  var lastQuery = '';

  // Remember the latest text typed in any search box.
  document.addEventListener('input', function (e) {
    if (e.target.matches && e.target.matches(INPUT)) {
      lastQuery = e.target.value.trim();
    }
  }, true);

  function currentQuery() {
    var inputs = document.querySelectorAll(INPUT);
    for (var i = 0; i < inputs.length; i++) {
      var v = inputs[i].value.trim();
      if (v) return v;
    }
    return lastQuery;
  }

  function searchUrl() {
    var q = currentQuery();
    return q ? '/search?q=' + encodeURIComponent(q) : '/search';
  }

  // Keep href correct for hover, middle-click and "open in new tab".
  document.addEventListener('mouseover', function (e) {
    var link = e.target.closest && e.target.closest(BUTTON);
    if (link) link.setAttribute('href', searchUrl());
  }, true);

  // Navigate on the earliest event, before the dropdown closes itself.
  function go(e) {
    var link = e.target.closest && e.target.closest(BUTTON);
    if (!link) return;
    if (e.type === 'mousedown' && e.button !== 0) {
      link.setAttribute('href', searchUrl());
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    var url = searchUrl();
    if (e.ctrlKey || e.metaKey) {
      window.open(url, '_blank');
    } else {
      window.location.href = url;
    }
  }
  document.addEventListener('mousedown', go, true);
  document.addEventListener('touchstart', go, { capture: true, passive: false });
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest(BUTTON);
    if (link) { e.preventDefault(); window.location.href = searchUrl(); }
  }, true);

  // Keyboard navigation for the search dropdown.
  // Arrow Down / Arrow Up move through the results (wrapping around),
  // Arrow Left / Arrow Right switch between collections and products,
  // Enter opens the highlighted result, or submits the search if none is highlighted.
  var RESULTS = '#dropdownList .app1-dropdown .search-bar__result-item, ' +
                '#dropdownList .app2-dropdown .sq-title a';
  var ACTIVE = 'sq-kb-active';
  var activeIndex = -1;

  function isVisible(el) {
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }

  function getResults() {
    return Array.prototype.filter.call(document.querySelectorAll(RESULTS), isVisible);
  }

  function clearActive() {
    var current = document.querySelectorAll('.' + ACTIVE);
    for (var i = 0; i < current.length; i++) current[i].classList.remove(ACTIVE);
    activeIndex = -1;
  }

  function setActive(results, index) {
    clearActive();
    activeIndex = index;
    var el = results[index];
    el.classList.add(ACTIVE);
    el.scrollIntoView({ block: 'nearest' });
  }

  // New typing starts the highlight from the top again.
  document.addEventListener('input', function (e) {
    if (e.target.matches && e.target.matches(INPUT)) clearActive();
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.isComposing) return;
    if (!(e.target.matches && e.target.matches(INPUT))) return;

    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      var results = getResults();
      if (!results.length) return;
      e.preventDefault();
      e.stopPropagation();
      var step = e.key === 'ArrowDown' ? 1 : -1;
      var start = activeIndex;
      if (start < 0 || start >= results.length) start = step === 1 ? -1 : 0;
      setActive(results, (start + step + results.length) % results.length);
      return;
    }

    // Arrow Left / Arrow Right jump between the collections and products columns,
    // keeping roughly the same row. Only while a result is highlighted, so the
    // keys still move the text cursor in the search box otherwise.
    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
      var current = document.querySelector('.' + ACTIVE);
      if (!current) return;
      e.preventDefault();
      e.stopPropagation();
      var all = getResults();
      var products = all.filter(function (el) { return el.closest('.app1-dropdown'); });
      var collections = all.filter(function (el) { return el.closest('.app2-dropdown'); });
      var fromList = current.closest('.app1-dropdown') ? products : collections;
      var toList = e.key === 'ArrowLeft' ? collections : products;
      if (fromList === toList || !toList.length) return;
      var row = Math.min(fromList.indexOf(current), toList.length - 1);
      setActive(all, all.indexOf(toList[Math.max(row, 0)]));
      return;
    }

    if (e.key === 'Escape') {
      clearActive();
      return;
    }

    if (e.key === 'Enter') {
      var active = document.querySelector('.' + ACTIVE);
      if (active && active.getAttribute('href')) {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = active.href;
        return;
      }
      var q = e.target.value.trim();
      if (!q) return;
      e.preventDefault();
      e.stopPropagation();
      window.location.href = '/search?q=' + encodeURIComponent(q);
    }
  }, true);
})();
